import React, { useState } from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import GrainIcon from '@mui/icons-material/Grain';
import sm1 from './images/sm1.jpeg'
import RiceBowlIcon from '@mui/icons-material/RiceBowl';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import { motion } from 'framer-motion';
import spiceprhdlg from './images/spicepr.jpg'
import garlicpowderimg from './images/garlicpowder.jpg'
import onionpowderimg from './images/onionpowderhd.avif'
import babyToysImage from './images/toyshs.jpg'
import babyGarmentsImage from './images/Twinning_Girls_Boys_Set.webp'
import webdesign from './images/webdesign.jpg'
import webdevelopment from './images/webdev.png'
import logodesign from './images/logo desgin.jpg'
import digitalmarketing from './images/digitalmarketing.jpg'
import pinkOnionFlakeImage from './images/Dehydrated Onion Flakes Supplier, Exporter _ Dehydratedveg_com.jpeg'
import garlicCloveImage from './images/GarlicClove.jpg'
import garlicChoppedImage from './images/GarlicMinced.jpeg'
import garlicMincedImage from './images/how-to-mince-garlic-2171-1.jpg'
import garlicGranulesImage from './images/GarlicGranules.jpg'
import pinkOnionGranulesImage from './images/PinkOnionGranules.webp'
import pinkOnionChoppedImage from './images/purple-onion-cut-half-pink-strips-visible-against-dark-background-344354882.webp'
import pinkOnionMincedImage from './images/pinkonionminced.jpg'
import pinkOnionPowderImage from './images/pinkonionpowder.jpg'
import whiteOnionFlakeImage from './images/whiteonionflakes.webp'
import whiteOnionGranulesImage from './images/whiteoniongranules.jpeg'
import whiteOnionChoppedImage from './images/dehydrated-white-onion-chopped-500x500.webp'
import whiteOnionMincedImage from './images/dehydrated-white-onion-minced-500x500.webp'
import whiteOnionPowderImage from './images/dehydrated-white-onion-powder.jpg'
import redOnionFlakeImage from './images/redonionflakes.webp'
import redOnionGranulesImage from './images/dehydrated-red-onion-granules-0-2-1-mm.jpg'
import redOnionChoppedImage from './images/red-onion-chopped-2-scaled-500x500.webp'
import redOnionMincedImage from './images/dehydrated-red-onion-minced-500x500.webp'
import redOnionPowderImage from './images/redonionpowder.jpg'
import friedOnionFreshImage from './images/organic-onion-fried-500x500.webp'
import friedCoatedWhiteOnionImage from './images/whitecoatedonion.webp'
import friedCoatedPinkOnionImage from './images/pink-coated-fried-onion.jpg'
import friedWhiteOnionFlakeImage from './images/friedcoatedmin.jpg'
import friedPinkOnionFlakeImage from './images/friedcoatedmin.jpg'
import gingerFlakeImage from './images/dehydrated-ginger-flakes.jpg'
import gingerPowderImage from './images/113563735.webp'
import greenChilliPowderImage from './images/dehydrated-green-chilli-powder-500x500.webp'
import tamarindPowderImage from './images/tamarind-powder-500x500.webp'
import tomatoPowderImage from './images/toamatopowder.jpg'
import mintPowderImage from './images/mint-leaves-pudina-patta-powder-2nd.jpeg'
import potatoPowderImage from './images/istockphoto-185902790-612x612.jpg'
import spinachPowderImage from './images/spinachpowder.jpg'
import mangoPowderImage from './images/AmchurPowder.webp'
import fenugreekPowderImage from './images/fenugreekpowderimg.jpg'
import lemonPowderImage from './images/07_Spray-Dried-Lemon-Powder-600x600.jpg'
import beetrootPowderImage from './images/DriedBeetrootPowder.webp'
import cheesePowderImage from './images/IMG_6946_800x.webp'
import corianderPowderImage from './images/CorianderPowder.webp'
import beetrootImage from './images/istockphoto-493446908-612x612.jpg'
import cabbageImage from './images/istockphoto-544313316-612x612.jpg'
import carrotImage from './images/carrots.jpg'
import tomatoImage from './images/istockphoto-98026003-612x612.jpg'
import gingerImage from './images/istockphoto-162711007-612x612.jpg'
import potatoImage from './images/istockphoto-1346299887-612x612.jpg'
import greenChilliImage  from './images/green-chilli-200-g-product-images-o590000187-p590000187-0-202409251830.webp'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router-dom';



const Products = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleClickOpen = (product) => {
    setSelectedProduct(product);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProduct(null);
  };


  const Background = styled(Box)({
    backgroundImage: `url(${'https://media.istockphoto.com/id/1366928508/photo/garlic-powder.jpg?s=612x612&w=0&k=20&c=f-CpEY6qMNOIzcx8jKveQRn3jGGDS8JrcRWHAvMkal0='})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    color: "white",
    filter: "brightness(0.5)",  // Darken background for readability
  });
  const SectionTitle = styled(Typography)({
    fontSize: "4rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    textAlign: "center",
    color: "#000",
    marginBottom: "1rem",
  });

  return (
   
      <div >
        <Background>
          <SectionTitle style={{ color: 'white' }}>
            Why Choose Unispeherexim?
          </SectionTitle>
          <Typography sx={{ textAlign: 'center', fontSize: '1.2rem', maxWidth: '800px', marginBottom: '30px', color: 'white' }}>
            We bridge the gap between international markets, offering seamless export solutions that ensure timely delivery, cost-efficiency, and high-quality service.
          </Typography>
          {/* <Typography variant="contained" sx={{  color: 'black', fontWeight: 'bold', borderRadius: '30px', padding: '10px 30px' }}>
                 Get Started
               </Typography> */}
        </Background>

 <Container maxWidth="lg" sx={{ py: 5 }}>
      <Typography
        variant="h2"
        style={{
          textAlign: 'center',
          fontWeight: 'bold',
          marginTop: 24,
          marginBottom: 16,
        }}
      >
         PRODUCT'S BY CATEGORIES
      </Typography>
      <Typography
        variant="h6"
        style={{
          textAlign: 'center',
          fontWeight: 'bold',
          marginTop: 24,
          marginBottom: 80,
          color: 'grey',
        }}
      >
        
      </Typography>

      <Grid container spacing={4}>
        {servicesData_1.map((service) => (
          <Grid item xs={12} sm={6} md={4} key={service.id}>
            <Card
              sx={{
                minHeight: 450,
                borderRadius: '16px',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                overflow: 'hidden',
                backgroundColor: '#1F473E',
                transition: 'transform 0.4s ease, box-shadow 0.4s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0 8px 16px rgba(0, 0, 0, 0.4)',
                },
              }}
            >
              <CardMedia
                component="img"
                alt={service.title}
                height="200"
                image={service.image}
              />
              <CardContent
                sx={{
                  textAlign: 'center',
                  color: '#fff',
                  backgroundColor: 'black',
                  p: 3,
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {service.title}
                </Typography>
                <Typography variant="body2" color="#D4C9B6" paragraph>
                  {service.description}
                </Typography>
                <Button
                  variant="outlined"
                  color="inherit"
                  sx={{margin:1}}
                  onClick={() => navigate(service.redirect)}
                >
                  Explore
                </Button>
                 <Button
                  variant="outlined"
                  color="inherit"
                  sx={{margin:1}}
                  onClick={() => navigate("/contact")}
                >
                  Contact Us
                  </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
        <Container maxWidth="lg" sx={{ py: 5 }}>
          <Typography variant='h2' style={{ textAlign: 'center', fontWeight: 'bold', marginTop: 3, marginBottom: 2 }}>ALL PRODUCTS </Typography>
          <Typography variant='h6' style={{ textAlign: 'center', fontWeight: 'bold', marginTop: 3, marginBottom: 10, color: 'grey' }}>WE SERVE </Typography>
          <Grid container spacing={4}>
          {servicesData.map((service) => (
            <Grid item xs={12} sm={6} md={4} key={service.id}>
              <Card
                sx={{
                  height: 420,
                  borderRadius: '16px',
                  boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                  overflow: 'hidden',
                  backgroundColor: '#1F473E',
                  transition: 'transform 0.4s ease, box-shadow 0.4s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.4)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  alt={service.title}
                  height="200"
                  image={service.image}
                />
                <CardContent sx={{ textAlign: 'center', color: '#fff', backgroundColor: 'black', p: 3 }}>
                  <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" color="#D4C9B6" paragraph>
                    {service.description}
                  </Typography>
                  <Button variant="outlined" color="inherit" onClick={() => handleClickOpen(service)}>
                    View More
                  </Button>
                   <Button
                  variant="outlined"
                  color="inherit"
                  sx={{margin:1}}
                  onClick={() => navigate("/contact")}
                >
                  Contact Us
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
          </Grid>
        </Container>
        <Container maxWidth="lg" sx={{ py: 5 }}>
          <Typography variant='h2' style={{ textAlign: 'center', fontWeight: 'bold', marginTop: 3, marginBottom: 2 }}>ADDITIONAL  </Typography>
          <Typography variant='h6' style={{ textAlign: 'center', fontWeight: 'bold', marginTop: 3, marginBottom: 10, color: 'grey' }}> SERVICES </Typography>
          <Grid container spacing={4}>
            {servicesData2.map((service) => (
              <Grid item xs={12} sm={6} md={4} key={service.id}>
                <Card
                  sx={{
                    position: 'relative',
                    height: 450,
                    borderRadius: '16px',
                    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                    transition: 'transform 0.4s ease, box-shadow 0.4s ease',
                    backgroundColor: '#1F473E',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.4)',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    alt={service.title}
                    height="200"
                    image={service.image}
                    sx={{
                      borderTopLeftRadius: '16px',
                      borderTopRightRadius: '16px',
                    }}
                  />
                  <CardContent
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      color: '#fff',
                      backgroundColor: '#1F473E',
                      p: 3,
                    }}
                  >
                    {/* <Box
                  sx={{
                    mb: 2,
                    fontSize: 40,
                    color: '#FF665A',
                  }}
                >
                  {service.icon}
                </Box> */}
                    <Typography
                      variant="h5"
                      component="div"
                      sx={{
                        fontFamily: '"Roboto", sans-serif',
                        fontWeight: 'bold',
                        mb: 1,
                      }}
                    >
                      {service.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#D4C9B6"
                      paragraph
                      sx={{
                        fontFamily: '"Roboto", sans-serif',
                      }}
                    >
                      {service.description}
                    </Typography>
                     <Button
                  variant="outlined"
                  color="inherit"
                  sx={{margin:1}}
                  onClick={() => navigate("/contact")}
                >
                  Contact Us
                  </Button>
                    {/* <Button
                  variant="contained"
                  size="small"
                  sx={{
                    textTransform: 'none',
                    backgroundColor: '#FF665A',
                    color: '#fff',
                    borderRadius: '20px',
                    px: 3,
                    '&:hover': {
                      backgroundColor: '#E5554D',
                    },
                  }}
                >
                  View More
                </Button> */}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        <Dialog
  open={open}
  onClose={handleClose}
  maxWidth="md"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 4,
      p: 2,
      backgroundColor: "#1e1e1e",
      color: "#f0f0f0",
      boxShadow: "0 0 20px rgba(0, 0, 0, 0.6)",
    },
  }}
>
  {/* Header with Close Button */}
  <Box display="flex" justifyContent="space-between" alignItems="center" px={2} pt={2}>
    <Typography variant="h5" fontWeight="bold" color="white">
      {selectedProduct?.title}
    </Typography>
    <IconButton onClick={handleClose} sx={{ color: "#bbb" }}>
      <CloseIcon />
    </IconButton>
  </Box>

  <DialogContent dividers sx={{ pt: 0, borderColor: "#333" }}>
    {/* Product Image */}
    <Box display="flex" justifyContent="center" my={2}>
      <img
        src={selectedProduct?.image}
        alt={selectedProduct?.title}
        style={{
          width: "100%",
          maxWidth: 400,
          borderRadius: 16,
          objectFit: "cover",
          boxShadow: "0 0 15px rgba(255, 255, 255, 0.05)",
        }}
      />
    </Box>

    {/* Description */}
    <DialogContentText
      sx={{
        fontSize: "1.05rem",
        color: "#ccc",
        lineHeight: 1.7,
        mt: 2,
        textAlign: "justify",
      }}
    >
      {selectedProduct?.detailedDescription}
    </DialogContentText>
  </DialogContent>
</Dialog>
      </div>
  
  );
};
const servicesData_1 = [
  // Onion Products - White
  {
    id: 11,
    title: 'Onion (White)',
    description: 'Offering premium white onion flakes, granules, and powdered varieties.',
    detailedDescription: 'Mild and subtle flavor, commonly used in dry soups, sauces, and seasoning blends.',
    image: whiteOnionFlakeImage,
    icon: <GrainIcon />,
    redirect: '/detailed-products-white-onion',
  },

  // Onion Products - Pink
  {
    id: 6,
    title: 'Onion (Pink)',
    description: 'Our pink onion range includes crispy flakes, chopped pieces, and fine powders.',
    detailedDescription: 'Retains the natural flavor and aroma of pink onions—ideal for seasoning and garnishing.',
    image: pinkOnionChoppedImage,
    icon: <GrainIcon />,
    redirect: '/detailed-products-pink-onion',
  },

  // Onion Products - Red
  {
    id: 16,
    title: 'Onion (Red)',
    description: 'Find high-quality red onion flakes, kibbled cuts, and powders in our range.',
    detailedDescription: 'Rich in flavor and aroma—great for garnishing and bulk spice blends.',
    image: redOnionChoppedImage,
    icon: <GrainIcon />,
    redirect: '/detailed-products-red-onion',
  },

  // Fried Onion Products
  {
    id: 21,
    title: 'Fried Onion',
    description: 'We offer crispy fried onions in various cuts and packaging options for all culinary needs.',
    detailedDescription: 'Perfect topping for biryanis, burgers, salads, and various snacks.',
    image: friedOnionFreshImage,
    icon: <GrainIcon />,
    redirect: "/detailed-products-fried-onions",
  },

  // Garlic Products
  {
    id: 1,
    title: 'Garlic',
    description: 'Explore a wide range of dehydrated garlic products including whole cloves, flakes, and powders.',
    detailedDescription: 'Convenient and long-lasting, perfect for adding a strong garlic flavor to dishes.',
    image: garlicCloveImage,
    icon: <GrainIcon />,
    redirect: '/detailed-products-garlic',
  },

  // Dehydrated Vegetables, Powders, and Spices
  {
    id: 40,
    title: 'Dehydrated Vegetables, Powders and Spices',
    description: 'Choose from our wide range of dehydrated vegetables like beetroot, carrot, and green peas, and spice powders including ginger, garlic, chili, and more.',
    detailedDescription: 'Nutritious and colorful—great for soups, salads, and healthy snacking.',
    image: beetrootImage,
    icon: <GrainIcon />,
    redirect: '/detailed-products-vegetable-powders-and-spices',
  },
];
const servicesData2 = [
  {
    id: 1,
    title: 'Website & Mobile App Design',
    description: 'Craft visually stunning and user-friendly website designs that captivate your audience.',
    image: webdesign,
    icon: <LocalFloristIcon />,
  },
  {
    id: 2,
    title: 'Website & Moblie App Development',
    description: 'Develop robust and scalable websites with the latest technologies and frameworks.',
    image: webdevelopment,
    icon: <RiceBowlIcon />,
  },
  {
    id: 3,
    title: 'Logo Design',
    description: 'Create unique and memorable logos that represent your brand identity.',
    image: logodesign,
    icon: <GrainIcon />,
  },
  {
    id: 4,
    title: 'Digital Marketing',
    description: 'Boost your online presence and reach your target audience through effective digital marketing strategies.',
    image: digitalmarketing,
    icon: <GrainIcon />,
  },
];





export default Products;
const servicesData = [
  // White Onion Products
  {
    id: 11,
    title: 'White Onion Flakes',
    description: 'Dehydrated white onion flakes.',
    detailedDescription: 'Mild flavor, perfect for dry soups and seasoning blends.',
    image: whiteOnionFlakeImage,
    icon: <GrainIcon />,
  },
  {
    id: 12,
    title: 'White Onion Granules (0.5–1 mm)',
    description: 'Granulated white onion.',
    detailedDescription: 'Blends easily in dry mixes and rubs.',
    image: whiteOnionGranulesImage,
    icon: <GrainIcon />,
  },
  {
    id: 13,
    title: 'White Onion Chopped (3–5 mm)',
    description: 'Chopped white onions.',
    detailedDescription: 'For visible texture in dishes and dehydrated meals.',
    image: whiteOnionChoppedImage,
    icon: <GrainIcon />,
  },
  {
    id: 14,
    title: 'White Onion Minced (1–3 mm)',
    description: 'Minced white onion.',
    detailedDescription: 'Great for even spread and milder onion flavor.',
    image: whiteOnionMincedImage,
    icon: <GrainIcon />,
  },
  {
    id: 15,
    title: 'White Onion Powder',
    description: 'Fine powder from dehydrated white onions.',
    detailedDescription: 'Mild flavor suitable for sauces, dips, and seasoning.',
    image: whiteOnionPowderImage,
    icon: <GrainIcon />,
  },

  // Pink Onion Products
  {
    id: 6,
    title: 'Pink Onion Flake',
    description: 'Crispy dehydrated pink onion flakes.',
    detailedDescription: 'Retains the flavor and aroma of pink onions, perfect for seasoning and garnishing.',
    image: pinkOnionFlakeImage,
    icon: <GrainIcon />,
  },
  {
    id: 7,
    title: 'Pink Onion Granules (0.5–1 mm)',
    description: 'Granulated form of pink onions.',
    detailedDescription: 'Offers easy blending in spice mixes and recipes.',
    image: pinkOnionGranulesImage,
    icon: <GrainIcon />,
  },
  {
    id: 8,
    title: 'Pink Onion Chopped',
    description: 'Chopped pink onion with good texture.',
    detailedDescription: 'Perfect for dehydrated mixes, soups, and dry spice packets.',
    image: pinkOnionChoppedImage,
    icon: <GrainIcon />,
  },
  {
    id: 9,
    title: 'Pink Onion Minced (1–3 mm)',
    description: 'Finely minced pink onions.',
    detailedDescription: 'Great for even flavor distribution in cooking.',
    image: pinkOnionMincedImage,
    icon: <GrainIcon />,
  },
  {
    id: 10,
    title: 'Pink Onion Powder',
    description: 'Powdered dehydrated pink onion.',
    detailedDescription: 'Adds flavor to spice mixes, seasonings, and condiments.',
    image: pinkOnionPowderImage,
    icon: <GrainIcon />,
  },

  // Red Onion Products
  {
    id: 16,
    title: 'Red Onion Flake',
    description: 'Dehydrated red onion flakes.',
    detailedDescription: 'Retains strong aroma and flavor. Perfect for garnish and bulk seasoning.',
    image: redOnionFlakeImage,
    icon: <GrainIcon />,
  },
  {
    id: 17,
    title: 'Red Onion Granules (0.5–1 mm)',
    description: 'Granulated red onions.',
    detailedDescription: 'Easy to use in spice blends or dry soups.',
    image: redOnionGranulesImage,
    icon: <GrainIcon />,
  },
  {
    id: 18,
    title: 'Red Onion Chopped (3–5 mm)',
    description: 'Chopped red onion.',
    detailedDescription: 'For visual and flavor enhancement in ready-to-eat meals.',
    image: redOnionChoppedImage,
    icon: <GrainIcon />,
  },
  {
    id: 19,
    title: 'Red Onion Minced (1–3 mm)',
    description: 'Minced red onion.',
    detailedDescription: 'Ideal for seasoning mixes and dry curry bases.',
    image: redOnionMincedImage,
    icon: <GrainIcon />,
  },
  {
    id: 20,
    title: 'Red Onion Powder',
    description: 'Fine red onion powder.',
    detailedDescription: 'Strong flavor, perfect for spice mixes.',
    image: redOnionPowderImage,
    icon: <GrainIcon />,
  },

  // Garlic Products
  {
    id: 1,
    title: 'Garlic Clove',
    description: 'Whole dehydrated garlic cloves.',
    detailedDescription: 'Perfect for adding strong garlic flavor to dishes with convenience and long shelf life.',
    image: garlicCloveImage,
    icon: <GrainIcon />,
  },
  {
    id: 2,
    title: 'Garlic Chopped (3–5 mm)',
    description: 'Coarsely chopped dehydrated garlic.',
    detailedDescription: 'Ideal for recipes that need texture and bite with garlic aroma.',
    image: garlicChoppedImage,
    icon: <GrainIcon />,
  },
  {
    id: 3,
    title: 'Garlic Minced (1–3 mm)',
    description: 'Finely minced dehydrated garlic.',
    detailedDescription: 'Even distribution and concentrated flavor for rubs, blends, and seasoning mixes.',
    image: garlicMincedImage,
    icon: <GrainIcon />,
  },
  {
    id: 4,
    title: 'Garlic Granules (0.5–1 mm)',
    description: 'Granulated garlic for versatile cooking.',
    detailedDescription: 'Great for seasoning blends, sauces, and spice applications.',
    image: garlicGranulesImage,
    icon: <GrainIcon />,
  },
  {
    id: 5,
    title: 'Garlic Powder',
    description: 'Aromatic fine powder made from dehydrated garlic cloves.',
    detailedDescription: 'Convenient, shelf-stable option for seasoning with intense garlic flavor.',
    image: garlicpowderimg,
    icon: <LocalFloristIcon />,
  },

  // Fried Onion Products
  {
    id: 21,
    title: 'Fresh Fried Onion',
    description: 'Ready-to-eat crispy fried onions.',
    detailedDescription: 'Used for toppings in biryanis, burgers, and salads.',
    image: friedOnionFreshImage,
    icon: <GrainIcon />,
  },
  {
    id: 22,
    title: 'Fried Coated White Onion',
    description: 'Coated white onion for extra crunch.',
    detailedDescription: 'Crispy and savory – ideal for snack seasoning or garnish.',
    image: friedCoatedWhiteOnionImage,
    icon: <GrainIcon />,
  },
  {
    id: 23,
    title: 'Fried Coated Pink Onion',
    description: 'Coated pink onion with extra crunch.',
    detailedDescription: 'Bold onion taste with crispy coating.',
    image: friedCoatedPinkOnionImage,
    icon: <GrainIcon />,
  },
  {
    id: 24,
    title: 'Fried White Onion Flakes',
    description: 'Flaky fried white onions.',
    detailedDescription: 'Delicious topping for fast foods and Indian cuisine.',
    image: friedWhiteOnionFlakeImage,
    icon: <GrainIcon />,
  },
  {
    id: 25,
    title: 'Fried Pink Onion Flakes',
    description: 'Flaky fried pink onions.',
    detailedDescription: 'Adds rich onion flavor with crispy texture.',
    image: friedPinkOnionFlakeImage,
    icon: <GrainIcon />,
  },

  // Vegetable Powders (Spices)
  {
    id: 26,
    title: 'Ginger Flake',
    description: 'Dried ginger flakes.',
    detailedDescription: 'Used in teas, pickles, and spice infusions.',
    image: gingerFlakeImage,
    icon: <GrainIcon />,
  },
  {
    id: 27,
    title: 'Ginger Powder',
    description: 'Finely ground ginger.',
    detailedDescription: 'For baking, spice blends, and masalas.',
    image: gingerPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 28,
    title: 'Green Chilli Powder',
    description: 'Hot green chili powder.',
    detailedDescription: 'Spicy addition to chutneys and marinades.',
    image: greenChilliPowderImage,
    icon: <GrainIcon />,
  },

  // Vegetable Powders (Others)
  {
    id: 29,
    title: 'Tamarind Powder',
    description: 'Tangy powdered tamarind.',
    detailedDescription: 'Great for spice mixes, chutneys, and Indian snacks.',
    image: tamarindPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 30,
    title: 'Tomato Powder',
    description: 'Spray-dried tomato powder.',
    detailedDescription: 'Perfect for soups, pastas, and seasonings.',
    image: tomatoPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 31,
    title: 'Mint Leaves Powder',
    description: 'Cool mint flavor in powdered form.',
    detailedDescription: 'Enhances chutneys and curd-based dishes.',
    image: mintPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 32,
    title: 'Potato Powder',
    description: 'Dehydrated potato in powder form.',
    detailedDescription: 'Used in snacks, bakery, and instant foods.',
    image: potatoPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 33,
    title: 'Spinach Powder',
    description: 'Nutrient-rich spinach powder.',
    detailedDescription: 'Used in smoothies, soups, and bakery items.',
    image: spinachPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 34,
    title: 'Dry Mango Powder',
    description: 'Tangy amchur powder.',
    detailedDescription: 'Used in chutneys, pickles, and curries.',
    image: mangoPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 35,
    title: 'Fenugreek Leaves Powder',
    description: 'Kasuri methi in powdered form.',
    detailedDescription: 'Adds aroma to Indian gravies and parathas.',
    image: fenugreekPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 36,
    title: 'Lemon Powder',
    description: 'Sour citrus powder.',
    detailedDescription: 'Adds tangy zest to seasonings and beverages.',
    image: lemonPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 37,
    title: 'Beetroot Powder',
    description: 'Vibrant red beet powder.',
    detailedDescription: 'Used in juices, snacks, and natural coloring.',
    image: beetrootPowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 38,
    title: 'Cheese Powder',
    description: 'Savory cheese flavor in powdered form.',
    detailedDescription: 'Ideal for pasta, popcorn, and snack foods.',
    image: cheesePowderImage,
    icon: <GrainIcon />,
  },
  {
    id: 39,
    title: 'Coriander Leaves Powder',
    description: 'Dhaniya leaf powder.',
    detailedDescription: 'Adds freshness and flavor to dals and curries.',
    image: corianderPowderImage,
    icon: <GrainIcon />,
  },

  // Dehydrated Vegetables
  {
    id: 40,
    title: 'Dehydrated Beetroot',
    description: 'Dried beetroot slices.',
    detailedDescription: 'For soups, salads, and health snacks.',
    image: beetrootImage,
    icon: <GrainIcon />,
  },
  {
    id: 41,
    title: 'Dehydrated Cabbage',
    description: 'Shredded and dried cabbage.',
    detailedDescription: 'Retains nutritional value and taste.',
    image: cabbageImage,
    icon: <GrainIcon />,
  },
  {
    id: 42,
    title: 'Dehydrated Carrot',
    description: 'Chopped or shredded dried carrots.',
    detailedDescription: 'Used in soups, noodles, and snacks.',
    image: carrotImage,
    icon: <GrainIcon />,
  },
  {
    id: 43,
    title: 'Dehydrated Tomato',
    description: 'Dried tomato flakes or slices.',
    detailedDescription: 'For instant soups and sauces.',
    image: tomatoImage,
    icon: <GrainIcon />,
  },
  {
    id: 44,
    title: 'Dehydrated Ginger',
    description: 'Sliced or chopped ginger root.',
    detailedDescription: 'Spicy and aromatic for teas and dishes.',
    image: gingerImage,
    icon: <GrainIcon />,
  },
  {
    id: 45,
    title: 'Dehydrated Potato',
    description: 'Dried potato chunks or slices.',
    detailedDescription: 'Shelf-stable, quick to rehydrate.',
    image: potatoImage,
    icon: <GrainIcon />,
  },
  {
    id: 46,
    title: 'Dehydrated Green Chilli',
    description: 'Hot green chili in dried form.',
    detailedDescription: 'Used in pickles, snacks, and seasonings.',
    image: greenChilliImage,
    icon: <GrainIcon />,
  }
];

